import Prompt from "../../../../contents/docs/integrate/_snippets/agent-prompt.mdx";
import * as React from 'react';
export default {
  Prompt,
  React
};